export default "__VITE_ASSET__fi5f$m3E__"